import Header from './Header';
import ConnectedHeader from './ConnectedHeader';

export { Header };
export default ConnectedHeader;
